import React from "react";
import { useSelector } from "react-redux";
import { selectTransactions, selectMode } from "../../../redux/merchantSlice";

const P = {
  white: "#FFFFFF", snow: "#FAFAFA", pearl: "#F5F5F0", cloud: "#E8E5DE",
  silver: "#B0ADA6", steel: "#8A8780", graphite: "#5C5955", ink: "#1A1815",
  gold: "#C9A84C", error: "#C44D4D", errorBg: "#FDE8E8", warn: "#D4952B", warnBg: "#FEF4E5", success: "#2D8B5F", successBg: "#E8F5EE",
};
const serif = "'Playfair Display', Georgia, serif";

export default function Disputes() {
  const mode = useSelector(selectMode);
  const txs  = useSelector(selectTransactions);
  const disputed = txs.filter(t => t.status === "disputed" || t.disputed);

  return (
    <div>
      <div style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 24, fontFamily: serif, fontWeight: 700, color: P.ink, marginBottom: 6 }}>Disputes</h2>
        <p style={{ fontSize: 13, color: P.steel }}>Manage chargebacks and payment disputes in {mode} mode.</p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 14, marginBottom: 28 }}>
        {[
          { label: "Open Disputes", val: "0", color: P.error, bg: P.errorBg },
          { label: "Under Review",  val: "0", color: P.warn,  bg: P.warnBg },
          { label: "Won",           val: "0", color: P.success, bg: P.successBg },
        ].map((s, i) => (
          <div key={i} style={{ background: P.white, borderRadius: 12, padding: "22px 20px", border: `1px solid ${P.cloud}` }}>
            <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: "0.1em", color: P.steel, marginBottom: 8, textTransform: "uppercase" as const }}>{s.label}</div>
            <div style={{ fontSize: 28, fontFamily: serif, fontWeight: 700, color: s.color }}>{s.val}</div>
          </div>
        ))}
      </div>

      <div style={{ background: P.white, borderRadius: 14, border: `1px solid ${P.cloud}`, overflow: "hidden" }}>
        <div style={{ padding: "20px 24px", borderBottom: `1px solid ${P.pearl}` }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: P.ink }}>All Disputes</div>
        </div>
        {disputed.length === 0 ? (
          <div style={{ padding: "60px 24px", textAlign: "center" }}>
            <div style={{ fontSize: 42, marginBottom: 16, opacity: 0.2 }}>⚡</div>
            <div style={{ fontSize: 14, color: P.graphite, fontWeight: 500, marginBottom: 4 }}>No disputes</div>
            <div style={{ fontSize: 12, color: P.silver }}>You're in great shape — no active disputes or chargebacks.</div>
          </div>
        ) : (
          disputed.map((d, i) => (
            <div key={d.id} style={{ padding: "14px 24px", borderBottom: `1px solid ${P.pearl}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500, color: P.ink }}>{d.customer_email || d.id.slice(0, 20)}</div>
                <div style={{ fontSize: 11, color: P.silver }}>{d.id}</div>
              </div>
              <span style={{ padding: "4px 10px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: P.errorBg, color: P.error }}>Disputed</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}